export default __webpack_public_path__ + "static/media/Wrench.18d751b4.svg";